import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProductDetails from "@/components/ProductDetails";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

const ProductPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  // Garantir que sempre começa do topo ao entrar na página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  
  // Se não tem ID, mostrar erro
  if (!id) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Produto não encontrado</h2>
          <button
            onClick={() => navigate("/")}
            className="text-primary hover:underline"
          >
            Voltar para a página inicial
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <ProductDetails
          productId={id}
          onBack={() => navigate("/#produtos")}
        />
      </main>
      <Footer />
    </div>
  );
};

export default ProductPage;